import { createSlice } from '@reduxjs/toolkit'
import { getFields } from '@utils/constants'

const THEME_CONFIG = {
  ...window.appData,
}

const initialState = {
  verificationDetails: {},
  contactDetails: getFields(THEME_CONFIG.fieldsSet.contactDetailsUpdate),
  bankDetails: getFields(THEME_CONFIG.fieldsSet.bankDetails),
  errors: {},
}

const updateSlice = createSlice({
  name: 'update',
  initialState,
  reducers: {
    setVerificationDetails: (state, action) => {
      state.verificationDetails = { ...state.verificationDetails, ...action.payload }
    },
    setContactDetails: (state, action) => {
      state.contactDetails = { ...state.contactDetails, ...action.payload }
    },
    setBankDetails: (state, action) => {
      state.bankDetails = { ...state.bankDetails, ...action.payload }
    },
    addErrors: (state, action) => {
      state.errors = action.payload
    },
  },
})

export const { setVerificationDetails, setContactDetails, setBankDetails, addErrors } = updateSlice.actions
export default updateSlice.reducer
